import React, { FC } from 'react';

type RepeatIconProps = {
  className?: string;
};

import './RepeatIcon.scss';

const RepeatIcon: FC<RepeatIconProps> = ({ className = '' }) => (
  <svg
    fill="#ffffff"
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    className={className}
  >
    <path
      d="M20.924 5.617a.997.997 0 0 0-.217-.324l-3-3a1 1 0 1 0-1.414 1.414L17.586 5H8a5 5 0 0 0-5 5v2a1 1 0 1 0 2 0v-2a3 3 0 0 1 3-3h9.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3A.997.997 0 0 0 21 6m-.076-.383a.996.996 0 0 1 .076.38l-.076-.38zm-17.848 12a.997.997 0 0 0 .217 1.09l3 3a1 1 0 0 0 1.414-1.414L6.414 19H16a5 5 0 0 0 5-5v-2a1 1 0 1 0-2 0v2a3 3 0 0 1-3 3H6.414l1.293-1.293a1 1 0 1 0-1.414-1.414l-3 3m-.217.324a.997.997 0 0 1 .215-.322l-.215.322z"
      fill="#ffffff"
    />
  </svg>
);

export default RepeatIcon;
